import request from '@/utils/request'
import axios from "axios";
import { addUrlPerFix } from "@/utils";
// 云租开店接口
export function addShopByClp(data) {
  return request({
    url: '/apis/sra/store/users/signup/addShopByClp', // 后端接口
    method: 'post',
    data
  })
}
//查询供货商信息
export function qrySupInfoListItem(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupInfoListItem', // 后端接口
    method: 'post',
    data
  })
}
//查询供货商信息
export function shopSubmit(data) {
  return request({
    url: '/apis/sra/oc/users/signup/shopSubmit', // 后端接口
    method: 'post',
    data
  })
}//查询供货商信息 
export function getWayChatPay(data) {
  return request({
    url: '/apis/sra/oc/users/signup/getWayChatPay', // 后端接口
    method: 'post',
    data
  })
}
// 查询支付状态
export function getStatus(data) {
  return request({
    url: '/apis/sra/oc/users/signup/getStatus', // 后端接口
    method: 'post',
    data
  })
}

// 附件下载 物流
export function templateDownloadwlxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/wlxt",
    data,
    {
      responseType: "blob"
    }
  );
}

// 附件下载 租赁
export function templateDownloadzlxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/zlxt",
    data,
    {
      responseType: "blob"
    }
  );
}
// 附件下载 二级集采
export function templateDownloadjcxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/jcxt",
    data,
    {
      responseType: "blob"
    }
  );
}
